import { AuthStep } from 'constants/shared/enums';
import { ReactNode, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    LOGIN,
    AUTH_OTP,
    AUTH_TELL_GATEWAY,
    AUTH_EMAIL,
    AUTH_OPEN_BANKING,
} from '../../../../constants/shared/routes';
import { useRestrictedAction } from 'hooks';

const getRouteForStep = (step: AuthStep) => {
    switch (step) {
        case AuthStep.EMAIL_SIGN_IN_FLOW:
        case AuthStep.EMAIL_ACTIVATION_FLOW:
            return AUTH_EMAIL;
        case AuthStep.OTP:
            return AUTH_OTP;
        case AuthStep.TELL_GATEWAY:
            return AUTH_TELL_GATEWAY;
        default:
            return LOGIN;
    }
};

interface ActivationGuardProps {
    children?: ReactNode;
}

export const ActivationGuard = ({ children }: ActivationGuardProps) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const authStep = localStorage.getItem('authStep') as AuthStep;
    const cognitoToken = localStorage.getItem('cognitoToken');
    const consentId = sessionStorage.getItem('consentId');

    const currentStep = getRouteForStep(authStep);
    const allowedRoute = pathname.includes(AUTH_OPEN_BANKING);
    const {
        isAccountRestricted,
        handleRestrictedAction,
    } = useRestrictedAction();

    useEffect(() => {
        if (allowedRoute) {
            if (isAccountRestricted)
                return handleRestrictedAction(navigate(LOGIN)!);
            return;
        }

        if (!consentId) {
            return navigate('/');
        }
        if (!cognitoToken && !authStep) {
            return navigate(LOGIN);
        }
        navigate(currentStep);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cognitoToken, consentId, allowedRoute, currentStep, authStep]);

    return <>{children}</>;
};
